// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import { SingleInputForm } from '../../../../../components/common';
import I18n from '../../../../../lib/i18n';

class SelectPreferredNumbers extends PureComponent<Props> {
  styles = getStyles();

  replaceSpaces = (value: ?string) => value && value.replace(' ', '');

  render() {
    return (
      <SingleInputForm
        onRequestClose={this.props.onRequestClose}
        onSubmitEditing={this.props.handleSubmit}
        maxLength={4}
        style={this.styles}
        keyboardType="phone-pad"
        name="numbers"
        title={I18n.t('SignUp.SelectPreferredNumbers.title')}
        buttonText={I18n.t('SignUp.SelectPreferredNumbers.tryThis')}
        normalize={this.replaceSpaces}
      />
    );
  }
}

type Props = {
  onRequestClose: () => void,
  handleSubmit: () => void,
};

export default SelectPreferredNumbers;

const getStyles = () =>
  StyleSheet.create({
    inputContainer: {
      width: 180,
      alignSelf: 'center',
    },
  });
